import React, { Component} from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';

@inject('inventorySupplierStore')
@observer
class InventorySupplier extends Component {
  render() {
    const { inventorySupplierStore, children } = this.props;
    return (
      <ItemList
        store={inventorySupplierStore}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'address', label: 'Address' },
          { key: 'contact_person', label: 'Contact Person' },
          { key: 'phone_number', label: 'Phone Number' },
          { key: 'email', label: 'Email' },
        ]}
        slug={'inventory/supplier'}
        resource={'inventory'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
    );
  }
}

export default InventorySupplier;



// WEBPACK FOOTER //
// ./src/components/Inventory/SupplierList.js